module.exports = __webpack_public_path__ + "img/logo-casa-bco.216efbcc.png";